package diana.soleil.design.iraniancanadienbazzar.feature.admin

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.lazy.LazyColumn
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AccentBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ChartSeries
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PersonAvatar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppConfirmDialog
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FullScreenImageViewer
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.NotificationBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.StatTile
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TrendLineChart
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.StatusBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.WindowWidthClass
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.windowWidthClassFor
import diana.soleil.design.iraniancanadienbazzar.core.model.DailyPlatformCounters
import diana.soleil.design.iraniancanadienbazzar.core.model.UserAccount
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.model.BusinessStatus
import diana.soleil.design.iraniancanadienbazzar.core.model.BusinessClaim
import diana.soleil.design.iraniancanadienbazzar.core.model.ClaimRole
import diana.soleil.design.iraniancanadienbazzar.core.model.Event
import diana.soleil.design.iraniancanadienbazzar.core.model.ListingRequest
import diana.soleil.design.iraniancanadienbazzar.core.model.ListingRequestType
import diana.soleil.design.iraniancanadienbazzar.core.model.ModerationAction
import diana.soleil.design.iraniancanadienbazzar.core.model.Report
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_approve
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_open_listing
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_brand
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_brand_sub
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_col_actions
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_col_business
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_col_category
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_col_location
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_col_member
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_col_role
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_growth_businesses
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_growth_empty
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_growth_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_growth_title
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_growth_users
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_make_admin
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_overview_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_overview_title
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_queue_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_queue_title
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_businesses
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_events
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_reports
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_claims
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_requests
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_listings
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_members
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_campaigns
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_audit
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_post_offer
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_rail_overview
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_revoke_admin
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_role_admin
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_role_user
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_role_label
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_stat_claims
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_stat_claims_caption
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_stat_listings
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_stat_listings_caption
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_stat_pending
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_stat_pending_caption
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_stat_reports
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_stat_reports_caption
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_contact
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_deny
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_grant
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_requested_by
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_role
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_role_employee
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_role_manager
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_role_other
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_role_owner
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_proof_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_proof_close_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_verification
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claim_view_proof
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_campaigns_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_claims_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_events_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_remove_target
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_restore_target
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_dismiss
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_audit_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_audit_line
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_audit_actor
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_role_moderator
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_make_moderator
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_remove_role
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_error
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_pending_badge
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_pending_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_all_listings_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_all_listings_search
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_all_listings_empty
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_status_approved
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_status_pending
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_status_rejected
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_status_suspended
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_cancel
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_remove_confirm_message
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_reject_confirm_message
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_edited_badge
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_edited_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_chip_content
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_content_publish
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_content_discard
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_content_discard_message
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_content_kind_news
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_content_kind_joke
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_content_kind_recipe
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_content_kind_fact
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_content_source
import diana.soleil.design.iraniancanadienbazzar.core.model.PendingContentItem
import diana.soleil.design.iraniancanadienbazzar.core.model.PendingContentKind
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_changes_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_change_name
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_change_category
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_change_address
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_change_apply
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_change_reject
import diana.soleil.design.iraniancanadienbazzar.core.model.ListingChangeRequest
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_reject
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_reject_reason_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_report_prefix
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_listing_requests_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_listing_request_removal
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_listing_request_correction
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_listing_request_privacy
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_listing_request_approve_removal
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_listing_request_reject
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_listing_request_removal_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_reports_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_resolve
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_retry
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_users_section
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.admin.resources.admin_title
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

/** Stateful entry point: pulls [AdminViewModel] from Koin and renders the stateless screen. */
@Composable
fun AdminRoute(
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    onOpenBusiness: (String) -> Unit = {},
    viewModel: AdminViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    var offerBusiness by remember { mutableStateOf<Business?>(null) }
    offerBusiness?.let { business -> AdminOfferSheet(business = business, onDismiss = { offerBusiness = null }) }
    AdminScreen(
        state = state,
        onBack = onBack,
        onPostOffer = { offerBusiness = it },
        onListingQueryChange = viewModel::setListingQuery,
        onApprove = viewModel::approve,
        onReject = viewModel::reject,
        onResolveReport = viewModel::resolveReport,
        onResolveListingRequest = viewModel::resolveListingRequest,
        onApproveListingRemoval = viewModel::approveListingRemoval,
        onRemoveReportTarget = { report -> viewModel.removeReportTarget(report) },
        onRestoreReportTarget = { report -> viewModel.restoreReportTarget(report) },
        onDismissReport = viewModel::dismissReport,
        onApproveClaim = viewModel::approveClaim,
        onRejectClaim = viewModel::rejectClaim,
        onApproveListingChange = viewModel::approveListingChange,
        onRejectListingChange = viewModel::rejectListingChange,
        onPublishContent = viewModel::publishContent,
        onDiscardContent = viewModel::discardContent,
        onApproveEvent = viewModel::approveEvent,
        onRejectEvent = viewModel::rejectEvent,
        onSetUserRole = viewModel::setUserRole,
        onOpenBusiness = onOpenBusiness,
        modifier = modifier,
    )
}

/**
 * Admin surface. Compact = the single-column queue list; Expanded (web/desktop, tablets) = the
 * Stitch `8581c6a2` dashboard shell: side rail (Overview + the real queues), KPI stat tiles fed by
 * live streams, and the verification-queue table. Deliberate deviations from the design (in-kdoc,
 * honest-UI rule): no Total Users / Monthly Revenue tiles, growth chart, activity feed, or global
 * search — those need backends (user counts, payments, activity log) that don't exist yet, and we
 * ship no fake data. DS components + tokens + string resources only.
 */
@Composable
fun AdminScreen(
    state: AdminUiState,
    onBack: () -> Unit,
    onApprove: (String) -> Unit,
    onReject: (String, String?) -> Unit,
    onResolveReport: (String) -> Unit,
    onResolveListingRequest: (String) -> Unit = {},
    onApproveListingRemoval: (ListingRequest) -> Unit = {},
    onRemoveReportTarget: (Report) -> Unit = {},
    onRestoreReportTarget: (Report) -> Unit = {},
    onDismissReport: (Report) -> Unit = {},
    onApproveClaim: (BusinessClaim) -> Unit = {},
    onRejectClaim: (BusinessClaim) -> Unit = {},
    onApproveListingChange: (ListingChangeRequest) -> Unit = {},
    onRejectListingChange: (ListingChangeRequest, String?) -> Unit = { _, _ -> },
    onPublishContent: (PendingContentItem) -> Unit = {},
    onDiscardContent: (PendingContentItem) -> Unit = {},
    onApproveEvent: (String) -> Unit = {},
    onRejectEvent: (String, String?) -> Unit = { _, _ -> },
    onSetUserRole: (uid: String, role: String) -> Unit = { _, _ -> },
    /** Opens the full listing (detail screen) so a moderator can review every field before deciding. */
    onOpenBusiness: (String) -> Unit = {},
    onPostOffer: (Business) -> Unit = {},
    onListingQueryChange: (String) -> Unit = {},
    modifier: Modifier = Modifier,
) {
    if (state.error) {
        ErrorState(
            message = stringResource(Res.string.admin_error),
            onRetry = onBack,
            retryLabel = stringResource(Res.string.admin_retry),
            modifier = modifier,
        )
        return
    }
    BoxWithConstraints(modifier = modifier.fillMaxSize()) {
        if (windowWidthClassFor(maxWidth) == WindowWidthClass.Expanded) {
            AdminDesktopShell(
                state = state,
                onBack = onBack,
                onApprove = onApprove,
                onReject = onReject,
                onResolveReport = onResolveReport,
                onResolveListingRequest = onResolveListingRequest,
                onApproveListingRemoval = onApproveListingRemoval,
                onRemoveReportTarget = onRemoveReportTarget,
                onRestoreReportTarget = onRestoreReportTarget,
                onDismissReport = onDismissReport,
                onApproveClaim = onApproveClaim,
                onRejectClaim = onRejectClaim,
                onApproveListingChange = onApproveListingChange,
                onRejectListingChange = onRejectListingChange,
                onPublishContent = onPublishContent,
                onDiscardContent = onDiscardContent,
                onApproveEvent = onApproveEvent,
                onRejectEvent = onRejectEvent,
                onSetUserRole = onSetUserRole,
                onOpenBusiness = onOpenBusiness,
                onPostOffer = onPostOffer,
                onListingQueryChange = onListingQueryChange,
            )
        } else {
            AdminQueueList(
                state = state,
                onBack = onBack,
                onApprove = onApprove,
                onReject = onReject,
                onResolveReport = onResolveReport,
                onResolveListingRequest = onResolveListingRequest,
                onApproveListingRemoval = onApproveListingRemoval,
                onRemoveReportTarget = onRemoveReportTarget,
                onRestoreReportTarget = onRestoreReportTarget,
                onDismissReport = onDismissReport,
                onApproveClaim = onApproveClaim,
                onRejectClaim = onRejectClaim,
                onApproveListingChange = onApproveListingChange,
                onRejectListingChange = onRejectListingChange,
                onPublishContent = onPublishContent,
                onDiscardContent = onDiscardContent,
                onApproveEvent = onApproveEvent,
                onRejectEvent = onRejectEvent,
                onSetUserRole = onSetUserRole,
                onOpenBusiness = onOpenBusiness,
                onPostOffer = onPostOffer,
                onListingQueryChange = onListingQueryChange,
            )
        }
    }
}

/** The Compact console: a chip row over the same sections the desktop rail offers. */
@Composable
private fun AdminQueueList(
    state: AdminUiState,
    onBack: () -> Unit,
    onApprove: (String) -> Unit,
    onReject: (String, String?) -> Unit,
    onResolveReport: (String) -> Unit,
    onResolveListingRequest: (String) -> Unit,
    onApproveListingRemoval: (ListingRequest) -> Unit,
    onRemoveReportTarget: (Report) -> Unit,
    onRestoreReportTarget: (Report) -> Unit,
    onDismissReport: (Report) -> Unit,
    onApproveClaim: (BusinessClaim) -> Unit,
    onRejectClaim: (BusinessClaim) -> Unit,
    onApproveListingChange: (ListingChangeRequest) -> Unit = {},
    onRejectListingChange: (ListingChangeRequest, String?) -> Unit = { _, _ -> },
    onPublishContent: (PendingContentItem) -> Unit = {},
    onDiscardContent: (PendingContentItem) -> Unit = {},
    onApproveEvent: (String) -> Unit,
    onRejectEvent: (String, String?) -> Unit,
    onSetUserRole: (uid: String, role: String) -> Unit = { _, _ -> },
    onOpenBusiness: (String) -> Unit = {},
    onPostOffer: (Business) -> Unit = {},
    onListingQueryChange: (String) -> Unit = {},
) {
    val isAdmin = state.isAdmin
    // Admins land on the Overview; moderators (no admin-only queues) land straight on Reports.
    var section by remember(isAdmin) { mutableStateOf(if (isAdmin) AdminSection.Overview else AdminSection.Reports) }
    val sections = buildList {
        if (isAdmin) {
            add(Triple(AdminSection.Overview, stringResource(Res.string.admin_rail_overview), 0))
            add(Triple(AdminSection.Businesses, stringResource(Res.string.admin_chip_businesses), state.pending.size + state.edited.size + state.listingChanges.size))
            add(Triple(AdminSection.Events, stringResource(Res.string.admin_chip_events), state.pendingEvents.size))
            add(Triple(AdminSection.Content, stringResource(Res.string.admin_chip_content), state.pendingContent.size))
        }
        add(Triple(AdminSection.Reports, stringResource(Res.string.admin_chip_reports), state.reports.size))
        if (isAdmin) {
            add(Triple(AdminSection.Claims, stringResource(Res.string.admin_chip_claims), state.claims.size))
            add(Triple(AdminSection.ListingRequests, stringResource(Res.string.admin_chip_requests), state.listingRequests.size))
            add(Triple(AdminSection.AllListings, stringResource(Res.string.admin_chip_listings), 0))
            add(Triple(AdminSection.Users, stringResource(Res.string.admin_chip_members), 0))
            add(Triple(AdminSection.Campaigns, stringResource(Res.string.admin_chip_campaigns), 0))
        }
        add(Triple(AdminSection.Audit, stringResource(Res.string.admin_chip_audit), 0))
    }
    Box(modifier = Modifier.fillMaxSize().background(AppTheme.colors.background).statusBarsPadding().navigationBarsPadding()) {
        LazyColumn(
            modifier = Modifier
                .fillMaxHeight()
                .widthIn(max = AppTheme.sizes.contentMaxWidth)
                .align(Alignment.TopCenter),
            contentPadding = PaddingValues(
                start = AppTheme.spacing.lg,
                end = AppTheme.spacing.lg,
                top = AppTheme.spacing.md,
                bottom = AppTheme.spacing.xl,
            ),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            item {
                AppIconButton(
                    iconName = "arrow_back",
                    contentDescription = stringResource(Res.string.admin_back_a11y),
                    onClick = onBack,
                    tint = AppTheme.colors.onSurface,
                )
            }
            item {
                Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
                    Text(
                        text = stringResource(Res.string.admin_title),
                        style = AppTheme.typography.headlineLg,
                        color = AppTheme.colors.onSurface,
                    )
                    Text(
                        text = stringResource(Res.string.admin_subtitle),
                        style = AppTheme.typography.bodyMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
            }

            if (state.loading) {
                item { LoadingState() }
                return@LazyColumn
            }
            // The phone console used to be one endless column (campaign composer first, then
            // every queue). Same sections as the desktop rail, as a chip row with live counts;
            // each chip shows exactly one section.
            item(key = "section_chips") {
                LazyRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                    items(sections.size, key = { sections[it].first.name }) { index ->
                        val (candidate, label, count) = sections[index]
                        AppChip(
                            label = if (count > 0) "$label · $count" else label,
                            selected = candidate == section,
                            onClick = { section = candidate },
                        )
                    }
                }
            }
            adminSectionItems(
                section = section,
                state = state,
                listingQuery = state.listingQuery,
                onListingQueryChange = onListingQueryChange,
                compact = true,
                onApprove = onApprove,
                onReject = onReject,
                onResolveListingRequest = onResolveListingRequest,
                onApproveListingRemoval = onApproveListingRemoval,
                onRemoveReportTarget = onRemoveReportTarget,
                onRestoreReportTarget = onRestoreReportTarget,
                onDismissReport = onDismissReport,
                onApproveClaim = onApproveClaim,
                onRejectClaim = onRejectClaim,
                onApproveListingChange = onApproveListingChange,
                onRejectListingChange = onRejectListingChange,
                onPublishContent = onPublishContent,
                onDiscardContent = onDiscardContent,
                onApproveEvent = onApproveEvent,
                onRejectEvent = onRejectEvent,
                onSetUserRole = onSetUserRole,
                onOpenBusiness = onOpenBusiness,
                onPostOffer = onPostOffer,
            )
        }
    }
}

private fun reportRemovable(targetType: String, isAdmin: Boolean): Boolean = when (targetType) {
    "review", "post", "marketplace_item" -> true
    "business" -> isAdmin
    else -> false
}

/** Which report targets can be restored (only soft-removed content; posts are hard-deleted). */
private fun reportRestorable(targetType: String, isAdmin: Boolean): Boolean = when (targetType) {
    "review", "marketplace_item" -> true
    "business" -> isAdmin
    else -> false
}

@Composable
private fun ListingRequestCardRow(
    request: ListingRequest,
    busy: Boolean,
    onResolve: () -> Unit,
    onApproveRemoval: () -> Unit,
) {
    // A Removal request is actionable: approving it must actually take the listing down (suspend the
    // business), so it gets Approve+Remove / Reject — not the bare "Resolve" that only closes the
    // ticket. Correction/Privacy are handled by the admin editing the listing, then resolving.
    val isRemoval = request.type == ListingRequestType.Removal
    var confirmRemove by remember { mutableStateOf(false) }
    if (confirmRemove) {
        AppConfirmDialog(
            title = stringResource(Res.string.admin_listing_request_approve_removal),
            message = stringResource(Res.string.admin_listing_request_removal_confirm, request.businessName),
            confirmLabel = stringResource(Res.string.admin_listing_request_approve_removal),
            cancelLabel = stringResource(Res.string.admin_cancel),
            destructive = true,
            onConfirm = { confirmRemove = false; onApproveRemoval() },
            onDismiss = { confirmRemove = false },
        )
    }
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Text(
                text = listingRequestTypeLabel(request.type) + " · " + request.businessName,
                style = AppTheme.typography.bodyLg,
                color = AppTheme.colors.onSurface,
            )
            Text(
                text = request.message,
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            request.contactEmail?.takeIf { it.isNotBlank() }?.let { email ->
                Text(text = email, style = AppTheme.typography.labelSm, color = AppTheme.colors.onSurfaceVariant)
            }
            if (isRemoval) {
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                    AppButton(
                        text = stringResource(Res.string.admin_listing_request_approve_removal),
                        onClick = { confirmRemove = true },
                        modifier = Modifier.weight(1f),
                        enabled = !busy,
                        loading = busy,
                        leadingIcon = "delete",
                    )
                    AppButton(
                        text = stringResource(Res.string.admin_listing_request_reject),
                        onClick = onResolve,
                        modifier = Modifier.weight(1f),
                        variant = AppButtonVariant.Secondary,
                        enabled = !busy,
                        leadingIcon = "close",
                    )
                }
            } else {
                AppButton(
                    text = stringResource(Res.string.admin_resolve),
                    onClick = onResolve,
                    modifier = Modifier.fillMaxWidth(),
                    variant = AppButtonVariant.Secondary,
                    enabled = !busy,
                    loading = busy,
                    leadingIcon = "task_alt",
                )
            }
        }
    }
}

@Composable
private fun listingRequestTypeLabel(type: ListingRequestType): String = stringResource(
    when (type) {
        ListingRequestType.Removal -> Res.string.admin_listing_request_removal
        ListingRequestType.Correction -> Res.string.admin_listing_request_correction
        ListingRequestType.Privacy -> Res.string.admin_listing_request_privacy
    },
)


/** Localized category name for a queue card, or null when the catalogue hasn't loaded yet. */
@Composable
private fun AdminUiState.categoryName(categoryId: String): String? {
    val lang = AppTheme.language
    return remember(categories, lang, categoryId) { categories.firstOrNull { it.id == categoryId }?.displayName(lang) }
}

@Composable
private fun PendingBusinessCard(
    business: Business,
    busy: Boolean,
    onApprove: () -> Unit,
    onReject: (reason: String?) -> Unit,
    onOpen: () -> Unit,
    badgeLabel: String? = null,
    /** Localized category name; falls back to the raw id when the catalogue hasn't loaded. */
    categoryLabel: String? = null,
) {
    var confirmReject by remember { mutableStateOf(false) }
    var rejectReason by remember { mutableStateOf("") }
    if (confirmReject) {
        AppConfirmDialog(
            title = stringResource(Res.string.admin_reject),
            message = stringResource(Res.string.admin_reject_confirm_message),
            confirmLabel = stringResource(Res.string.admin_reject),
            cancelLabel = stringResource(Res.string.admin_cancel),
            destructive = true,
            inputValue = rejectReason,
            onInputChange = { rejectReason = it },
            inputPlaceholder = stringResource(Res.string.admin_reject_reason_placeholder),
            onConfirm = { confirmReject = false; onReject(rejectReason.takeIf { it.isNotBlank() }); rejectReason = "" },
            onDismiss = { confirmReject = false; rejectReason = "" },
        )
    }
    // The whole card opens the full listing: a moderator has to see every field (hours, photos,
    // contact, description in all three languages) before approving — the queue row is a summary.
    AppCard(modifier = Modifier.fillMaxWidth(), onClick = onOpen) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                verticalAlignment = Alignment.Top,
            ) {
                // weight(1f) + ellipsis: a long name wraps within its own column instead of
                // squeezing the badge into a sliver (owner report, 2026-09-10).
                Text(
                    text = business.name,
                    style = AppTheme.typography.bodyLg,
                    color = AppTheme.colors.onSurface,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.weight(1f),
                )
                StatusBadge(label = badgeLabel ?: stringResource(Res.string.admin_pending_badge))
            }
            Text(
                text = listOf(categoryLabel ?: business.categoryId, business.address.city, business.address.province)
                    .filter { it.isNotBlank() }
                    .joinToString(" · "),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
            val description = business.description.resolve(AppTheme.language)
            if (!description.isNullOrBlank()) {
                Text(
                    text = description,
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                    maxLines = 3,
                    overflow = TextOverflow.Ellipsis,
                )
            }
            AppButton(
                text = stringResource(Res.string.admin_open_listing),
                onClick = onOpen,
                variant = AppButtonVariant.Text,
                leadingIcon = "open_in_new",
            )
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                AppButton(
                    text = stringResource(Res.string.admin_approve),
                    onClick = onApprove,
                    modifier = Modifier.weight(1f),
                    enabled = !busy,
                    loading = busy,
                    leadingIcon = "check",
                )
                AppButton(
                    text = stringResource(Res.string.admin_reject),
                    onClick = { confirmReject = true },
                    modifier = Modifier.weight(1f),
                    variant = AppButtonVariant.Secondary,
                    enabled = !busy,
                    leadingIcon = "close",
                )
            }
        }
    }
}

@Composable
private fun ClaimRequestCard(
    claim: BusinessClaim,
    busy: Boolean,
    onApprove: () -> Unit,
    onReject: () -> Unit,
) {
    var confirmDeny by remember { mutableStateOf(false) }
    if (confirmDeny) {
        AppConfirmDialog(
            title = stringResource(Res.string.admin_claim_deny),
            message = stringResource(Res.string.admin_reject_confirm_message),
            confirmLabel = stringResource(Res.string.admin_claim_deny),
            cancelLabel = stringResource(Res.string.admin_cancel),
            destructive = true,
            onConfirm = { confirmDeny = false; onReject() },
            onDismiss = { confirmDeny = false },
        )
    }
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Text(text = claim.businessName, style = AppTheme.typography.bodyLg, color = AppTheme.colors.onSurface)
            Text(
                text = stringResource(Res.string.admin_claim_requested_by, claim.claimantName),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Text(
                text = stringResource(Res.string.admin_claim_role, claimRoleLabel(claim.role)),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
            val contact = listOf(claim.contactEmail, claim.contactPhone)
                .filter { it.isNotBlank() }
                .joinToString(" · ")
            if (contact.isNotBlank()) {
                Text(
                    text = stringResource(Res.string.admin_claim_contact, contact),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
            if (claim.message.isNotBlank()) {
                Text(
                    text = stringResource(Res.string.admin_claim_verification, claim.message),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurface,
                )
            }
            val proofUrl = claim.documentRef
            if (proofUrl != null) {
                var viewingProof by remember { mutableStateOf(false) }
                AppButton(
                    text = stringResource(Res.string.admin_claim_view_proof),
                    onClick = { viewingProof = true },
                    modifier = Modifier.fillMaxWidth(),
                    variant = AppButtonVariant.Secondary,
                    leadingIcon = "image",
                )
                if (viewingProof) {
                    FullScreenImageViewer(
                        imageUrls = listOf(proofUrl),
                        closeContentDescription = stringResource(Res.string.admin_claim_proof_close_a11y),
                        onDismiss = { viewingProof = false },
                        imageContentDescription = stringResource(Res.string.admin_claim_proof_a11y),
                    )
                }
            }
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                AppButton(
                    text = stringResource(Res.string.admin_claim_grant),
                    onClick = onApprove,
                    modifier = Modifier.weight(1f),
                    enabled = !busy,
                    loading = busy,
                    leadingIcon = "verified_user",
                )
                AppButton(
                    text = stringResource(Res.string.admin_claim_deny),
                    onClick = { confirmDeny = true },
                    modifier = Modifier.weight(1f),
                    variant = AppButtonVariant.Secondary,
                    enabled = !busy,
                    leadingIcon = "close",
                )
            }
        }
    }
}

/** Localized label for the claimant's stated relationship to the business. */
@Composable
private fun claimRoleLabel(role: ClaimRole): String = stringResource(
    when (role) {
        ClaimRole.Owner -> Res.string.admin_claim_role_owner
        ClaimRole.Manager -> Res.string.admin_claim_role_manager
        ClaimRole.Employee -> Res.string.admin_claim_role_employee
        ClaimRole.Other -> Res.string.admin_claim_role_other
    },
)

@Composable
private fun PendingEventCard(
    event: Event,
    busy: Boolean,
    onApprove: () -> Unit,
    onReject: (reason: String?) -> Unit,
) {
    var confirmReject by remember { mutableStateOf(false) }
    var rejectReason by remember { mutableStateOf("") }
    if (confirmReject) {
        AppConfirmDialog(
            title = stringResource(Res.string.admin_reject),
            message = stringResource(Res.string.admin_reject_confirm_message),
            confirmLabel = stringResource(Res.string.admin_reject),
            cancelLabel = stringResource(Res.string.admin_cancel),
            destructive = true,
            inputValue = rejectReason,
            onInputChange = { rejectReason = it },
            inputPlaceholder = stringResource(Res.string.admin_reject_reason_placeholder),
            onConfirm = { confirmReject = false; onReject(rejectReason.takeIf { it.isNotBlank() }); rejectReason = "" },
            onDismiss = { confirmReject = false; rejectReason = "" },
        )
    }
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Text(
                text = event.title.resolve(AppTheme.language).orEmpty(),
                style = AppTheme.typography.bodyLg,
                color = AppTheme.colors.onSurface,
            )
            Text(
                text = listOf(event.venue.name, event.venue.city).filter { it.isNotBlank() }.joinToString(" · "),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                AppButton(
                    text = stringResource(Res.string.admin_approve),
                    onClick = onApprove,
                    modifier = Modifier.weight(1f),
                    enabled = !busy,
                    loading = busy,
                    leadingIcon = "check",
                )
                AppButton(
                    text = stringResource(Res.string.admin_reject),
                    onClick = { confirmReject = true },
                    modifier = Modifier.weight(1f),
                    variant = AppButtonVariant.Secondary,
                    enabled = !busy,
                    leadingIcon = "close",
                )
            }
        }
    }
}

@Composable
private fun ReportCardRow(
    report: Report,
    busy: Boolean,
    canRemove: Boolean,
    canRestore: Boolean,
    onRemoveTarget: () -> Unit,
    onRestoreTarget: () -> Unit,
    onDismiss: () -> Unit,
) {
    // Guard the irreversible content removal behind a confirmation (was a one-tap hard action).
    var confirmRemove by remember { mutableStateOf(false) }
    if (confirmRemove) {
        AppConfirmDialog(
            title = stringResource(Res.string.admin_remove_target),
            message = stringResource(Res.string.admin_remove_confirm_message, report.targetType),
            confirmLabel = stringResource(Res.string.admin_remove_target),
            cancelLabel = stringResource(Res.string.admin_cancel),
            destructive = true,
            onConfirm = { confirmRemove = false; onRemoveTarget() },
            onDismiss = { confirmRemove = false },
        )
    }
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Text(
                text = stringResource(Res.string.admin_report_prefix, report.targetType, report.targetId),
                style = AppTheme.typography.bodyLg,
                color = AppTheme.colors.onSurface,
            )
            Text(
                text = report.reason,
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                if (canRemove) {
                    AppButton(
                        text = stringResource(Res.string.admin_remove_target),
                        onClick = { confirmRemove = true },
                        modifier = Modifier.weight(1f),
                        enabled = !busy,
                        loading = busy,
                        leadingIcon = "delete",
                    )
                }
                if (canRestore) {
                    AppButton(
                        text = stringResource(Res.string.admin_restore_target),
                        onClick = onRestoreTarget,
                        modifier = Modifier.weight(1f),
                        variant = AppButtonVariant.Secondary,
                        enabled = !busy,
                        leadingIcon = "restore",
                    )
                }
                AppButton(
                    text = stringResource(Res.string.admin_dismiss),
                    onClick = onDismiss,
                    modifier = Modifier.weight(1f),
                    variant = AppButtonVariant.Secondary,
                    enabled = !busy,
                    leadingIcon = "task_alt",
                )
            }
        }
    }
}

/** One line of the moderation audit trail: what an actor did to which target, and when. */
@Composable
private fun ModerationLogRow(action: ModerationAction) {
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.md),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        ) {
            Text(
                text = stringResource(
                    Res.string.admin_audit_line,
                    action.action,
                    action.targetType,
                    action.targetId,
                ),
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurface,
            )
            Text(
                text = stringResource(Res.string.admin_audit_actor, action.actorUid),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
            action.reason?.takeIf { it.isNotBlank() }?.let { reason ->
                Text(
                    text = reason,
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }
    }
}

// ---------------------------------------------------------------------------------------------
// Desktop shell (Stitch 8581c6a2) — Expanded widths only.
// ---------------------------------------------------------------------------------------------

private enum class AdminSection { Overview, Businesses, Content, AllListings, Claims, Events, Reports, ListingRequests, Audit, Users, Campaigns }

@Composable
private fun AdminDesktopShell(
    state: AdminUiState,
    onBack: () -> Unit,
    onApprove: (String) -> Unit,
    onReject: (String, String?) -> Unit,
    onResolveReport: (String) -> Unit,
    onResolveListingRequest: (String) -> Unit,
    onApproveListingRemoval: (ListingRequest) -> Unit,
    onRemoveReportTarget: (Report) -> Unit,
    onRestoreReportTarget: (Report) -> Unit,
    onDismissReport: (Report) -> Unit,
    onApproveClaim: (BusinessClaim) -> Unit,
    onRejectClaim: (BusinessClaim) -> Unit,
    onApproveListingChange: (ListingChangeRequest) -> Unit = {},
    onRejectListingChange: (ListingChangeRequest, String?) -> Unit = { _, _ -> },
    onPublishContent: (PendingContentItem) -> Unit = {},
    onDiscardContent: (PendingContentItem) -> Unit = {},
    onApproveEvent: (String) -> Unit,
    onRejectEvent: (String, String?) -> Unit,
    onSetUserRole: (uid: String, role: String) -> Unit,
    onOpenBusiness: (String) -> Unit = {},
    onPostOffer: (Business) -> Unit = {},
    onListingQueryChange: (String) -> Unit = {},
) {
    // Admins land on the Overview; moderators (no admin-only queues) land straight on Reports.
    var section by remember(state.isAdmin) {
        mutableStateOf(if (state.isAdmin) AdminSection.Overview else AdminSection.Reports)
    }
    Row(modifier = Modifier.fillMaxSize().background(AppTheme.colors.background).statusBarsPadding().navigationBarsPadding()) {
        AdminRail(
            state = state,
            selected = section,
            onSelect = { section = it },
            onBack = onBack,
        )
        LazyColumn(
            modifier = Modifier.weight(1f).fillMaxHeight(),
            contentPadding = PaddingValues(AppTheme.spacing.xl),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
        ) {
            if (state.loading) {
                item { LoadingState() }
                return@LazyColumn
            }
            adminSectionItems(
                section = section,
                state = state,
                listingQuery = state.listingQuery,
                onListingQueryChange = onListingQueryChange,
                compact = false,
                onApprove = onApprove,
                onReject = onReject,
                onResolveListingRequest = onResolveListingRequest,
                onApproveListingRemoval = onApproveListingRemoval,
                onRemoveReportTarget = onRemoveReportTarget,
                onRestoreReportTarget = onRestoreReportTarget,
                onDismissReport = onDismissReport,
                onApproveClaim = onApproveClaim,
                onRejectClaim = onRejectClaim,
                onApproveListingChange = onApproveListingChange,
                onRejectListingChange = onRejectListingChange,
                onPublishContent = onPublishContent,
                onDiscardContent = onDiscardContent,
                onApproveEvent = onApproveEvent,
                onRejectEvent = onRejectEvent,
                onSetUserRole = onSetUserRole,
                onOpenBusiness = onOpenBusiness,
                onPostOffer = onPostOffer,
            )
        }
    }
}


/**
 * One section of the console, as LazyColumn items. Shared by the desktop shell (side rail) and the
 * compact shell (chip row) so the two never drift: the queues, the cards and the actions are the
 * same code — only the frame around them differs by width class.
 */
private fun LazyListScope.adminSectionItems(
    section: AdminSection,
    state: AdminUiState,
    listingQuery: String,
    onListingQueryChange: (String) -> Unit,
    compact: Boolean,
    onApprove: (String) -> Unit,
    onReject: (String, String?) -> Unit,
    onResolveListingRequest: (String) -> Unit,
    onApproveListingRemoval: (ListingRequest) -> Unit,
    onRemoveReportTarget: (Report) -> Unit,
    onRestoreReportTarget: (Report) -> Unit,
    onDismissReport: (Report) -> Unit,
    onApproveClaim: (BusinessClaim) -> Unit,
    onRejectClaim: (BusinessClaim) -> Unit,
    onApproveListingChange: (ListingChangeRequest) -> Unit = {},
    onRejectListingChange: (ListingChangeRequest, String?) -> Unit = { _, _ -> },
    onPublishContent: (PendingContentItem) -> Unit = {},
    onDiscardContent: (PendingContentItem) -> Unit = {},
    onApproveEvent: (String) -> Unit,
    onRejectEvent: (String, String?) -> Unit,
    onSetUserRole: (uid: String, role: String) -> Unit,
    onOpenBusiness: (String) -> Unit,
    onPostOffer: (Business) -> Unit = {},
) {
    when (section) {
        AdminSection.Overview -> overviewItems(state, onApprove, onReject, onOpenBusiness, compact)
        AdminSection.AllListings -> allListingsItems(state, listingQuery, onListingQueryChange, onPostOffer)
        AdminSection.Businesses -> {
            queueItems(
                items = state.pending,
                key = { "b_" + it.id },
                title = null,
            ) { business ->
                PendingBusinessCard(
                    business = business,
                    busy = business.id in state.busyIds,
                    onApprove = { onApprove(business.id) },
                    onReject = { reason -> onReject(business.id, reason) },
                    onOpen = { onOpenBusiness(business.id) },
                    categoryLabel = state.categoryName(business.categoryId),
                )
            }
            // BIZ-5 — post-approval owner edits awaiting a re-review pass.
            if (state.edited.isNotEmpty()) {
                item { SectionHeader(title = stringResource(Res.string.admin_edited_section)) }
                items(count = state.edited.size, key = { "eb_" + state.edited[it].id }) { index ->
                    val business = state.edited[index]
                    PendingBusinessCard(
                        business = business,
                        busy = business.id in state.busyIds,
                        onApprove = { onApprove(business.id) },
                        onReject = { reason -> onReject(business.id, reason) },
                        onOpen = { onOpenBusiness(business.id) },
                        badgeLabel = stringResource(Res.string.admin_edited_badge),
                        categoryLabel = state.categoryName(business.categoryId),
                    )
                }
            }
            // Owner-requested name/category/address changes — nothing is live until applied here.
            if (state.listingChanges.isNotEmpty()) {
                item { SectionHeader(title = stringResource(Res.string.admin_changes_section)) }
                items(count = state.listingChanges.size, key = { "lc_" + state.listingChanges[it].id }) { index ->
                    val request = state.listingChanges[index]
                    ListingChangeCard(
                        request = request,
                        busy = request.id in state.busyIds,
                        currentCategoryLabel = state.categoryName(request.currentCategoryId) ?: request.currentCategoryId,
                        proposedCategoryLabel = request.proposedCategoryId?.let { state.categoryName(it) ?: it },
                        onApply = { onApproveListingChange(request) },
                        onReject = { reason -> onRejectListingChange(request, reason) },
                        onOpen = { onOpenBusiness(request.businessId) },
                    )
                }
            }
        }
        AdminSection.Claims -> queueItems(
            items = state.claims,
            key = { "c_" + it.id },
            title = null,
        ) { claim ->
            ClaimRequestCard(
                claim = claim,
                busy = claim.id in state.busyIds,
                onApprove = { onApproveClaim(claim) },
                onReject = { onRejectClaim(claim) },
            )
        }
        AdminSection.Content -> queueItems(
            items = state.pendingContent,
            key = { "pc_" + it.kind.name + "_" + it.id },
            title = null,
        ) { item ->
            PendingContentCard(
                item = item,
                busy = item.id in state.busyIds,
                onPublish = { onPublishContent(item) },
                onDiscard = { onDiscardContent(item) },
            )
        }
        AdminSection.Events -> queueItems(
            items = state.pendingEvents,
            key = { "e_" + it.id },
            title = null,
        ) { event ->
            PendingEventCard(
                event = event,
                busy = event.id in state.busyIds,
                onApprove = { onApproveEvent(event.id) },
                onReject = { reason -> onRejectEvent(event.id, reason) },
            )
        }
        AdminSection.Users -> usersItems(state, onSetUserRole)
        AdminSection.Campaigns -> item(key = "campaign_composer") { CampaignComposerCard() }
        AdminSection.Reports -> queueItems(
            items = state.reports,
            key = { "r_" + it.id },
            title = null,
        ) { report ->
            ReportCardRow(
                report = report,
                busy = report.id in state.busyIds,
                canRemove = reportRemovable(report.targetType, state.isAdmin),
                canRestore = reportRestorable(report.targetType, state.isAdmin),
                onRemoveTarget = { onRemoveReportTarget(report) },
                onRestoreTarget = { onRestoreReportTarget(report) },
                onDismiss = { onDismissReport(report) },
            )
        }
        // Canadian-privacy obligation: listing removal/correction/privacy requests are now
        // reachable in the desktop shell too (were compact-queue-only).
        AdminSection.ListingRequests -> queueItems(
            items = state.listingRequests,
            key = { "lr_" + it.id },
            title = null,
        ) { request ->
            ListingRequestCardRow(
                request = request,
                busy = request.id in state.busyIds,
                onResolve = { onResolveListingRequest(request.id) },
                onApproveRemoval = { onApproveListingRemoval(request) },
            )
        }
        AdminSection.Audit -> queueItems(
            items = state.moderationLog,
            key = { "ma_" + it.id },
            title = null,
        ) { action -> ModerationLogRow(action = action) }
    }
}

/** Generic queue section body: EmptyState when the stream is empty, otherwise one card per item. */
private fun <T> LazyListScope.queueItems(
    items: List<T>,
    key: (T) -> String,
    title: String?,
    card: @Composable (T) -> Unit,
) {
    if (title != null) {
        item { SectionHeader(title = title) }
    }
    if (items.isEmpty()) {
        item {
            EmptyState(
                title = stringResource(Res.string.admin_empty_title),
                description = stringResource(Res.string.admin_empty_desc),
            )
        }
    } else {
        items(count = items.size, key = { key(items[it]) }) { index ->
            Box(modifier = Modifier.widthIn(max = AppTheme.sizes.contentMaxWidthCompact * 2)) {
                card(items[index])
            }
        }
    }
}

private fun LazyListScope.overviewItems(
    state: AdminUiState,
    onApprove: (String) -> Unit,
    onReject: (String, String?) -> Unit,
    onOpenBusiness: (String) -> Unit = {},
    /** Phone width: tiles wrap 2×2 and the queue shows cards instead of the table. */
    compact: Boolean = false,
) {
    // The compact shell already carries the "Admin" header; a second headline under the chips
    // would just push the numbers below the fold.
    if (!compact) item {
        Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
            Text(
                text = stringResource(Res.string.admin_overview_title),
                style = AppTheme.typography.headlineLg,
                color = AppTheme.colors.onSurface,
            )
            Text(
                text = stringResource(Res.string.admin_overview_subtitle),
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
        }
    }
    item {
        // Four tiles in one row on desktop (Stitch 8581c6a2); two rows of two on a phone so the
        // numbers stay readable instead of four slivers.
        val listings: @Composable RowScope.() -> Unit = {
            StatTile(
                iconName = "business_center",
                label = stringResource(Res.string.admin_stat_listings),
                value = state.listingsTotal.toString(),
                caption = stringResource(Res.string.admin_stat_listings_caption),
                modifier = Modifier.weight(1f),
            )
            StatTile(
                iconName = "pending_actions",
                label = stringResource(Res.string.admin_stat_pending),
                value = state.pending.size.toString(),
                caption = stringResource(Res.string.admin_stat_pending_caption),
                accentColor = AppTheme.colors.onSecondaryContainer,
                accentContainer = AppTheme.colors.secondaryContainer,
                modifier = Modifier.weight(1f),
            )
        }
        val people: @Composable RowScope.() -> Unit = {
            StatTile(
                iconName = "how_to_reg",
                label = stringResource(Res.string.admin_stat_claims),
                value = state.claims.size.toString(),
                caption = stringResource(Res.string.admin_stat_claims_caption),
                modifier = Modifier.weight(1f),
            )
            StatTile(
                iconName = "report_problem",
                label = stringResource(Res.string.admin_stat_reports),
                value = state.reports.size.toString(),
                caption = stringResource(Res.string.admin_stat_reports_caption),
                accentColor = AppTheme.colors.error,
                accentContainer = AppTheme.colors.errorContainer,
                captionColor = if (state.reports.isNotEmpty()) AppTheme.colors.error else AppTheme.colors.onSurfaceVariant,
                modifier = Modifier.weight(1f),
            )
        }
        if (compact) {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) { listings() }
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) { people() }
            }
        } else {
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg)) {
                listings()
                people()
            }
        }
    }
    item { GrowthCard(state.growth) }
    item {
        Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
            Text(
                text = stringResource(Res.string.admin_queue_title),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onSurface,
            )
            Text(
                text = stringResource(Res.string.admin_queue_subtitle),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
        }
    }
    if (state.pending.isEmpty()) {
        item {
            EmptyState(
                title = stringResource(Res.string.admin_empty_title),
                description = stringResource(Res.string.admin_empty_desc),
            )
        }
    } else if (compact) {
        // A table is unreadable at phone width — the same queue as cards, capped so Overview stays
        // an overview; the Businesses chip lists the rest.
        val preview = state.pending.take(OVERVIEW_QUEUE_PREVIEW)
        items(count = preview.size, key = { "ov_" + preview[it].id }) { index ->
            val business = preview[index]
            PendingBusinessCard(
                business = business,
                busy = business.id in state.busyIds,
                onApprove = { onApprove(business.id) },
                onReject = { reason -> onReject(business.id, reason) },
                onOpen = { onOpenBusiness(business.id) },
                categoryLabel = state.categoryName(business.categoryId),
            )
        }
    } else {
        item { VerificationTable(state, onApprove, onReject, onOpenBusiness) }
    }
}

private const val OVERVIEW_QUEUE_PREVIEW = 3

/**
 * "All listings" browser — recent listings of any status with a client-side name search. Fills the gap
 * where the console only ever surfaced the (often-empty) pending queue; now an admin can find and
 * inspect any listing at any time.
 */
private fun LazyListScope.allListingsItems(
    state: AdminUiState,
    query: String,
    onQueryChange: (String) -> Unit,
    onPostOffer: (Business) -> Unit = {},
) {
    item(key = "all_listings_header") {
        Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            Text(
                text = stringResource(Res.string.admin_all_listings_section),
                style = AppTheme.typography.headlineLg,
                color = AppTheme.colors.onSurface,
            )
            AppTextField(
                value = query,
                onValueChange = onQueryChange,
                placeholder = stringResource(Res.string.admin_all_listings_search),
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
    val q = query.trim()
    // Blank → the recent window; typed → whole-directory prefix search from the VM, merged with
    // any local matches so results appear while the server round-trip is in flight.
    val filtered = if (q.isEmpty()) state.allBusinesses
        else (state.searchedBusinesses + state.allBusinesses.filter { it.name.contains(q, ignoreCase = true) })
            .distinctBy { it.id }
    if (filtered.isEmpty()) {
        item(key = "all_listings_empty") {
            EmptyState(title = stringResource(Res.string.admin_all_listings_empty))
        }
    } else {
        items(count = filtered.size, key = { "all_" + filtered[it].id }) { index ->
            AllListingRow(filtered[index], onPostOffer = { onPostOffer(filtered[index]) })
        }
    }
}

/** One row in the "All listings" browser: name + city, with a status badge. */
@Composable
private fun AllListingRow(business: Business, onPostOffer: () -> Unit = {}) {
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppTheme.spacing.md),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs)) {
                    Text(
                        text = business.name,
                        style = AppTheme.typography.bodyLg,
                        color = AppTheme.colors.onSurface,
                    )
                    Text(
                        text = business.address.city.ifBlank { business.categoryId },
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
                StatusBadge(label = adminStatusLabel(business.status))
            }
            // Offers gathered by phone get posted here while merchant claims are still rare.
            if (business.status == BusinessStatus.Approved) {
                AppButton(
                    text = stringResource(Res.string.admin_post_offer),
                    onClick = onPostOffer,
                    variant = AppButtonVariant.Text,
                    leadingIcon = "sell",
                )
            }
        }
    }
}

/** Localized label for a listing's moderation status (All-listings browser badges). */
@Composable
private fun adminStatusLabel(status: BusinessStatus): String = stringResource(
    when (status) {
        BusinessStatus.Approved -> Res.string.admin_status_approved
        BusinessStatus.Pending -> Res.string.admin_status_pending
        BusinessStatus.Rejected -> Res.string.admin_status_rejected
        BusinessStatus.Suspended -> Res.string.admin_status_suspended
    },
)

/** Stitch's verification-queue table: header row + one row per pending business. */
@Composable
private fun VerificationTable(
    state: AdminUiState,
    onApprove: (String) -> Unit,
    onReject: (String, String?) -> Unit,
    onOpenBusiness: (String) -> Unit = {},
) {
    val lang = AppTheme.language
    val categoryNames = remember(state.categories, lang) {
        state.categories.associate { it.id to it.displayName(lang) }
    }
    // The Overview verification table is the primary desktop reject surface — guard it like the cards.
    var rejectConfirmId by remember { mutableStateOf<String?>(null) }
    var rejectReason by remember { mutableStateOf("") }
    rejectConfirmId?.let { id ->
        AppConfirmDialog(
            title = stringResource(Res.string.admin_reject),
            message = stringResource(Res.string.admin_reject_confirm_message),
            confirmLabel = stringResource(Res.string.admin_reject),
            cancelLabel = stringResource(Res.string.admin_cancel),
            destructive = true,
            inputValue = rejectReason,
            onInputChange = { rejectReason = it },
            inputPlaceholder = stringResource(Res.string.admin_reject_reason_placeholder),
            onConfirm = { rejectConfirmId = null; onReject(id, rejectReason.takeIf { it.isNotBlank() }); rejectReason = "" },
            onDismiss = { rejectConfirmId = null; rejectReason = "" },
        )
    }
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.surfaceContainer)
                    .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
            ) {
                TableHeaderCell(stringResource(Res.string.admin_col_business), weight = 2f)
                TableHeaderCell(stringResource(Res.string.admin_col_category), weight = 1f)
                TableHeaderCell(stringResource(Res.string.admin_col_location), weight = 1f)
                TableHeaderCell(stringResource(Res.string.admin_col_actions), weight = 1f)
            }
            state.pending.forEach { business ->
                // The row opens the full listing; Approve/Reject stay in the actions column.
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { onOpenBusiness(business.id) }
                        .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Row(
                        modifier = Modifier.weight(2f),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                    ) {
                        Box(
                            modifier = Modifier
                                .size(AppTheme.sizes.iconCircle)
                                .background(AppTheme.colors.secondaryContainer, AppTheme.shapes.md),
                            contentAlignment = Alignment.Center,
                        ) {
                            Text(
                                text = business.name.take(1).uppercase(),
                                style = AppTheme.typography.labelMd,
                                color = AppTheme.colors.onSecondaryContainer,
                            )
                        }
                        Column {
                            Text(
                                text = business.name,
                                style = AppTheme.typography.labelMd,
                                color = AppTheme.colors.onSurface,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                            )
                            Text(
                                text = business.website.orEmpty(),
                                style = AppTheme.typography.labelSm,
                                color = AppTheme.colors.onSurfaceVariant,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                            )
                        }
                    }
                    Box(modifier = Modifier.weight(1f)) {
                        StatusBadge(label = categoryNames[business.categoryId] ?: business.categoryId)
                    }
                    Text(
                        text = listOf(business.address.city, business.address.province)
                            .filter { it.isNotBlank() }
                            .joinToString(", "),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSurfaceVariant,
                        modifier = Modifier.weight(1f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                    Row(
                        modifier = Modifier.weight(1f),
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    ) {
                        val busy = business.id in state.busyIds
                        AppButton(
                            text = stringResource(Res.string.admin_approve),
                            onClick = { onApprove(business.id) },
                            variant = AppButtonVariant.Text,
                            enabled = !busy,
                            loading = busy,
                        )
                        AppButton(
                            text = stringResource(Res.string.admin_reject),
                            onClick = { rejectConfirmId = business.id },
                            variant = AppButtonVariant.Text,
                            enabled = !busy,
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun RowScope.TableHeaderCell(label: String, weight: Float) {
    Text(
        text = label,
        style = AppTheme.typography.labelMd,
        color = AppTheme.colors.onSurfaceVariant,
        modifier = Modifier.weight(weight),
    )
}

@Composable
private fun AdminRail(
    state: AdminUiState,
    selected: AdminSection,
    onSelect: (AdminSection) -> Unit,
    onBack: () -> Unit,
) {
    Column(
        modifier = Modifier
            .width(AppTheme.sizes.navRailWidth)
            .fillMaxHeight()
            .background(AppTheme.colors.surface)
            .padding(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            modifier = Modifier.padding(bottom = AppTheme.spacing.lg),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.admin_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onSurfaceVariant,
            )
            Column {
                Text(
                    text = stringResource(Res.string.admin_brand),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                )
                Text(
                    text = stringResource(Res.string.admin_brand_sub),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }
        // Destinations scroll on short windows so the last items never clip under the identity card.
        Column(
            modifier = Modifier.weight(1f).verticalScroll(rememberScrollState()),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        ) {
            // Full admins see every destination; moderators see only the moderation ones.
            if (state.isAdmin) {
                RailItem("dashboard", stringResource(Res.string.admin_rail_overview), selected == AdminSection.Overview, count = 0) { onSelect(AdminSection.Overview) }
                RailItem("storefront", stringResource(Res.string.admin_pending_section), selected == AdminSection.Businesses, count = state.pending.size) { onSelect(AdminSection.Businesses) }
                RailItem("inventory_2", stringResource(Res.string.admin_all_listings_section), selected == AdminSection.AllListings, count = 0) { onSelect(AdminSection.AllListings) }
                RailItem("how_to_reg", stringResource(Res.string.admin_claims_section), selected == AdminSection.Claims, count = state.claims.size) { onSelect(AdminSection.Claims) }
                RailItem("calendar_today", stringResource(Res.string.admin_events_section), selected == AdminSection.Events, count = state.pendingEvents.size) { onSelect(AdminSection.Events) }
                RailItem("newspaper", stringResource(Res.string.admin_chip_content), selected == AdminSection.Content, count = state.pendingContent.size) { onSelect(AdminSection.Content) }
            }
            RailItem("flag", stringResource(Res.string.admin_reports_section), selected == AdminSection.Reports, count = state.reports.size) { onSelect(AdminSection.Reports) }
            if (state.isAdmin) {
                RailItem("privacy_tip", stringResource(Res.string.admin_listing_requests_section), selected == AdminSection.ListingRequests, count = state.listingRequests.size) { onSelect(AdminSection.ListingRequests) }
            }
            RailItem("shield", stringResource(Res.string.admin_audit_section), selected == AdminSection.Audit, count = 0) { onSelect(AdminSection.Audit) }
            if (state.isAdmin) {
                RailItem("group", stringResource(Res.string.admin_users_section), selected == AdminSection.Users, count = 0) { onSelect(AdminSection.Users) }
                RailItem("campaign", stringResource(Res.string.admin_campaigns_section), selected == AdminSection.Campaigns, count = 0) { onSelect(AdminSection.Campaigns) }
            }
        }
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.tile)
                .padding(AppTheme.spacing.md),
        ) {
            Box(
                modifier = Modifier
                    .size(AppTheme.sizes.iconCircle)
                    .background(AppTheme.colors.secondaryContainer, AppTheme.shapes.pill),
                contentAlignment = Alignment.Center,
            ) {
                AppIcon(name = "person", size = AppTheme.sizes.iconMd, tint = AppTheme.colors.onSecondaryContainer)
            }
            Column {
                Text(
                    text = stringResource(Res.string.admin_title),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.onSurface,
                )
                Text(
                    text = stringResource(Res.string.admin_role_label),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }
    }
}

@Composable
private fun RailItem(
    iconName: String,
    label: String,
    selected: Boolean,
    count: Int,
    onClick: () -> Unit,
) {
    val container = if (selected) AppTheme.colors.primaryContainer else AppTheme.colors.surface
    val content = if (selected) AppTheme.colors.onPrimary else AppTheme.colors.onSurfaceVariant
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(AppTheme.shapes.md)
            .background(container)
            .clickable(onClick = onClick)
            .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.md),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        AppIcon(name = iconName, size = AppTheme.sizes.iconMd, tint = content, filled = selected)
        Text(
            text = label,
            style = AppTheme.typography.labelMd,
            color = content,
            modifier = Modifier.weight(1f),
        )
        NotificationBadge(count = count, contentDescription = count.toString())
    }
}

private fun LazyListScope.usersItems(
    state: AdminUiState,
    onSetUserRole: (uid: String, role: String) -> Unit,
) {
    item {
        Text(
            text = stringResource(Res.string.admin_users_section),
            style = AppTheme.typography.headlineLg,
            color = AppTheme.colors.onSurface,
        )
    }
    if (state.users.isEmpty()) {
        item {
            EmptyState(
                title = stringResource(Res.string.admin_empty_title),
                description = stringResource(Res.string.admin_empty_desc),
            )
        }
        return
    }
    item {
        AppCard(modifier = Modifier.fillMaxWidth()) {
            Column {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(AppTheme.colors.surfaceContainer)
                        .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
                ) {
                    TableHeaderCell(stringResource(Res.string.admin_col_member), weight = 2f)
                    TableHeaderCell(stringResource(Res.string.admin_col_role), weight = 1f)
                    TableHeaderCell(stringResource(Res.string.admin_col_actions), weight = 1f)
                }
                state.users.forEach { user ->
                    UserRow(
                        user = user,
                        isSelf = user.uid == state.currentUid,
                        busy = user.uid in state.busyIds,
                        onSetUserRole = onSetUserRole,
                    )
                }
            }
        }
    }
}

@Composable
private fun UserRow(
    user: UserAccount,
    isSelf: Boolean,
    busy: Boolean,
    onSetUserRole: (uid: String, role: String) -> Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Row(
            modifier = Modifier.weight(2f),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            PersonAvatar(
                id = user.uid,
                name = user.displayName ?: user.uid,
                size = AppTheme.sizes.iconCircle,
                textStyle = AppTheme.typography.labelMd,
            )
            Column {
                Text(
                    text = user.displayName ?: user.uid,
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.onSurface,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = listOfNotNull(user.metroId, user.preferredLanguage).joinToString(" · "),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.onSurfaceVariant,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
            }
        }
        Box(modifier = Modifier.weight(1f)) {
            when {
                user.isAdmin -> AccentBadge(label = stringResource(Res.string.admin_role_admin))
                user.isModerator -> AccentBadge(label = stringResource(Res.string.admin_role_moderator))
                else -> StatusBadge(label = stringResource(Res.string.admin_role_user))
            }
        }
        // Role controls: promote through user → moderator → admin, or step back down. A moderator is a
        // scoped delegate (reports + content hide/restore); an admin has the full console.
        Column(
            modifier = Modifier.weight(1f),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs),
        ) {
            when {
                user.isAdmin -> {
                    AppButton(
                        text = stringResource(Res.string.admin_revoke_admin),
                        onClick = { onSetUserRole(user.uid, UserAccount.ROLE_USER) },
                        variant = AppButtonVariant.Text,
                        enabled = !busy && !isSelf,
                        loading = busy,
                    )
                }
                user.isModerator -> {
                    AppButton(
                        text = stringResource(Res.string.admin_make_admin),
                        onClick = { onSetUserRole(user.uid, UserAccount.ROLE_ADMIN) },
                        variant = AppButtonVariant.Text,
                        enabled = !busy,
                        loading = busy,
                    )
                    AppButton(
                        text = stringResource(Res.string.admin_remove_role),
                        onClick = { onSetUserRole(user.uid, UserAccount.ROLE_USER) },
                        variant = AppButtonVariant.Text,
                        enabled = !busy,
                    )
                }
                else -> {
                    AppButton(
                        text = stringResource(Res.string.admin_make_moderator),
                        onClick = { onSetUserRole(user.uid, UserAccount.ROLE_MODERATOR) },
                        variant = AppButtonVariant.Text,
                        enabled = !busy,
                        loading = busy,
                    )
                    AppButton(
                        text = stringResource(Res.string.admin_make_admin),
                        onClick = { onSetUserRole(user.uid, UserAccount.ROLE_ADMIN) },
                        variant = AppButtonVariant.Text,
                        enabled = !busy,
                    )
                }
            }
        }
    }
}

/**
 * Stitch's "Growth Analytics" bento card, honest edition: real Functions-maintained daily buckets
 * rendered with [TrendLineChart]; a plain caption when fewer than two days of data exist (the chart
 * needs two points to draw a line — no fake series).
 */
@Composable
private fun GrowthCard(growth: List<DailyPlatformCounters>) {
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs)) {
                Text(
                    text = stringResource(Res.string.admin_growth_title),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                )
                Text(
                    text = stringResource(Res.string.admin_growth_subtitle),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
            if (growth.size < 2) {
                Text(
                    text = stringResource(Res.string.admin_growth_empty),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            } else {
                TrendLineChart(
                    series = listOf(
                        ChartSeries(
                            label = stringResource(Res.string.admin_growth_users),
                            values = growth.map { it.users.toFloat() },
                            color = AppTheme.colors.primary,
                        ),
                        ChartSeries(
                            label = stringResource(Res.string.admin_growth_businesses),
                            values = growth.map { it.businesses.toFloat() },
                            color = AppTheme.colors.secondary,
                        ),
                    ),
                )
            }
        }
    }
}

/** One owner change request: old → new for each proposed field, with Apply / Reject (reason optional). */
@Composable
private fun ListingChangeCard(
    request: ListingChangeRequest,
    busy: Boolean,
    currentCategoryLabel: String,
    proposedCategoryLabel: String?,
    onApply: () -> Unit,
    onReject: (reason: String?) -> Unit,
    onOpen: () -> Unit,
) {
    var confirmReject by remember { mutableStateOf(false) }
    var rejectReason by remember { mutableStateOf("") }
    if (confirmReject) {
        AppConfirmDialog(
            title = stringResource(Res.string.admin_change_reject),
            message = stringResource(Res.string.admin_reject_confirm_message),
            confirmLabel = stringResource(Res.string.admin_change_reject),
            cancelLabel = stringResource(Res.string.admin_cancel),
            destructive = true,
            inputValue = rejectReason,
            onInputChange = { rejectReason = it },
            onConfirm = { confirmReject = false; onReject(rejectReason.ifBlank { null }) },
            onDismiss = { confirmReject = false },
        )
    }
    AppCard(modifier = Modifier.fillMaxWidth(), onClick = onOpen) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Text(text = request.businessName, style = AppTheme.typography.bodyLg, color = AppTheme.colors.onSurface)
            request.proposedName?.let {
                Text(
                    text = stringResource(Res.string.admin_change_name, request.currentName, it),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurface,
                )
            }
            proposedCategoryLabel?.let {
                Text(
                    text = stringResource(Res.string.admin_change_category, currentCategoryLabel, it),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurface,
                )
            }
            request.proposedAddress?.let {
                Text(
                    text = stringResource(
                        Res.string.admin_change_address,
                        request.currentAddress?.formatted().orEmpty(),
                        it.formatted(),
                    ),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurface,
                )
            }
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                AppButton(
                    text = stringResource(Res.string.admin_change_reject),
                    onClick = { confirmReject = true },
                    variant = AppButtonVariant.Secondary,
                    enabled = !busy,
                    modifier = Modifier.weight(1f),
                )
                AppButton(
                    text = stringResource(Res.string.admin_change_apply),
                    onClick = onApply,
                    loading = busy,
                    enabled = !busy,
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}

/** A hidden news/joke/recipe/fact card: what users would see, its source, and Publish / Discard. */
@Composable
private fun PendingContentCard(
    item: PendingContentItem,
    busy: Boolean,
    onPublish: () -> Unit,
    onDiscard: () -> Unit,
) {
    val lang = AppTheme.language
    val uriHandler = androidx.compose.ui.platform.LocalUriHandler.current
    var confirmDiscard by remember { mutableStateOf(false) }
    if (confirmDiscard) {
        AppConfirmDialog(
            title = stringResource(Res.string.admin_content_discard),
            message = stringResource(Res.string.admin_content_discard_message),
            confirmLabel = stringResource(Res.string.admin_content_discard),
            cancelLabel = stringResource(Res.string.admin_cancel),
            destructive = true,
            onConfirm = { confirmDiscard = false; onDiscard() },
            onDismiss = { confirmDiscard = false },
        )
    }
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            StatusBadge(
                label = stringResource(
                    when (item.kind) {
                        PendingContentKind.News -> Res.string.admin_content_kind_news
                        PendingContentKind.Joke -> Res.string.admin_content_kind_joke
                        PendingContentKind.Recipe -> Res.string.admin_content_kind_recipe
                        PendingContentKind.Fact -> Res.string.admin_content_kind_fact
                    },
                ),
            )
            item.title?.resolve(lang)?.takeIf { it.isNotBlank() }?.let {
                Text(text = it, style = AppTheme.typography.bodyLg, color = AppTheme.colors.onSurface)
            }
            item.text.resolve(lang).takeIf { it.isNotBlank() }?.let {
                Text(text = it, style = AppTheme.typography.bodyMd, color = AppTheme.colors.onSurfaceVariant)
            }
            item.linkUrl?.takeIf { it.isNotBlank() }?.let { url ->
                AppButton(
                    text = stringResource(Res.string.admin_content_source),
                    onClick = { uriHandler.openUri(url) },
                    variant = AppButtonVariant.Secondary,
                    leadingIcon = "open_in_new",
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                AppButton(
                    text = stringResource(Res.string.admin_content_discard),
                    onClick = { confirmDiscard = true },
                    variant = AppButtonVariant.Secondary,
                    enabled = !busy,
                    modifier = Modifier.weight(1f),
                )
                AppButton(
                    text = stringResource(Res.string.admin_content_publish),
                    onClick = onPublish,
                    loading = busy,
                    enabled = !busy,
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}
